module.exports = __webpack_public_path__ + "img/login.6dc6499a.jpg";